import { EventAdapter } from '~analytics/adapters/EventAdapter';
import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

export class CreateRoomEventAdapter extends EventAdapter {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = function sendCreateRoomEvent() {
    sendTeacherAmplitudeEvent(EventTypes.CreateRoom);
  };

  constructor() {
    super();

    this.eventData = {};
  }
}
